import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

/**
 * Human-readable difference between two dates of the form "2m" or "49m 2s".
 * @remarks
 * Luxon 2.x does not support `Duration.toHuman()`. After upgrading to Luxon 3.x,
 * replace this logic with `Duration.toHuman()`.
 */
@Pipe({
    name: 'timeBetween',
    pure: false,
    standalone: false
})
export class TimeBetweenPipe implements PipeTransform {
    transform(start: DateTime | null, end: DateTime | null): string | null {
        if (!start || !end) {
            return null;
        }

        const diff = end.diff(start, ['minutes', 'seconds']).normalize();

        const minutes = diff.minutes;
        const seconds = Math.floor(diff.seconds);

        let result = '';
        if (minutes > 0) {
            result += `${minutes}m`;
        }
        if (seconds > 0) {
            result += (result ? ' ' : '') + `${seconds}s`;
        }

        return result || '1s';
    }
}
